import ajaxService from './ajaxService';

export default {
  // 產生digest
  getDigest(companyId, memberSourceId, body) {
    const payload = JSON.stringify(body);
    return ajaxService.post('/sso/post/api/v1/digest', { companyId, memberSourceId, payload });
  },
  // 取得會員權杖
  getAccessToken(body, headers) {
    return ajaxService.post('/sso/post/api/v1/accesstoken/code', body, headers);
  },
  // 驗證 accessToken
  verifiyAccesstoken(headers) {
    return ajaxService.post('/sso/post/api/v1/accesstoken-decorder', {}, headers);
  },
  // 取得指定的頁面設定
  getPageSetting(body) {
    return ajaxService.post('/sso/post/api/v1/setting/basic-query/page', body);
  },
  // 取得生效之公司授權資訊
  getCompanyPermission(param) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/sso/get/api/v1/company-permission?${queryString}`);
  },
  // 取得城市列表
  getCountrys() {
    return ajaxService.post('/sso/get/api/v1/countrys');
  },
  // 取得郵遞區號
  getzipcode() {
    return ajaxService.post('/sso/get/api/v1/getzipcode');
  },
  async postDynamicLogin(body) {
    try {
      const res = await ajaxService.post('/sso/post/api/v1/dynamic-login', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  async postDigest(body) {
    try {
      const res = await ajaxService.post('/sso/post/api/v1/digest', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  async getMemberSourceSetting(params) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const res = await ajaxService.post(`/sso/get/api/v1/member-source-setting?${queryString}`);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  // 驗證碼新增(對內)
  postMobileVerifyCode(body) {
    return ajaxService.post('/sso/post/api/v1/mobile-verify-code', body);
  },
  // 驗證碼驗證(對內)
  postMobileVerifycodeVerifier(body) {
    return ajaxService.post('/sso/post/api/v1/mobile-verifycode-verifier', body);
  },
  // 取得手機驗證設定
  getMobileVerifySetting(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/sso/get/api/v1/MobileVerifySetting?${queryString}`);
  },
  postWording(body) {
    return ajaxService.post('/sso/post/api/v1/wording', body);
  },
  // 生成會員資料一次性代碼(對內)
  getNewCodeByAccesstoken(headers) {
    return ajaxService.post('/sso/post/api/v1/code', {}, headers);
  },
  async getAPIToken() {
    try {
      const res = await ajaxService.post('/sso/get/api/v1/apiauth', {});
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  async postAPIToken() {
    try {
      const res = await ajaxService.post('/sso/post/api/v1/apiauth', {});
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
};
